import ErrorHamster from "@/assets/images/error-hamster.svg";

const errorContainerStyle = {
  marginTop: "8%",
};

export const ErrorFallback = () => {
  return (
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
      <div className="text-center" style={errorContainerStyle}>
        <img
          alt="Something went wrong image"
          src={ErrorHamster}
          className="img-fluid pb-1"
          aria-label="Ooops.. something went wrong"
        />
        <p className="fw-bold fs-9">
          <span className="fs-5">Oops...something went wrong.</span>
          <br />
          Try refreshing the page. If the problem persists, please{" "}
          <a href="mailto:support@uptime.com">contact support</a>.
        </p>
      </div>
    </div>
  );
};
